import { render, staticRenderFns } from "./CustomFooter.vue?vue&type=template&id=13d6456a&scoped=true&"
import script from "./CustomFooter.vue?vue&type=script&lang=js&"
export * from "./CustomFooter.vue?vue&type=script&lang=js&"
import style0 from "./CustomFooter.vue?vue&type=style&index=0&id=13d6456a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d6456a",
  null
  
)

export default component.exports